import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Storage from '../utils/storageES.js'
import HomeButton from './HomeButton.jsx'
import PremiumGate from './PremiumGate.jsx'

function Luggage({ userData, onNavigate, embedded = false }) {
  const { t } = useTranslation()
  const [checklist, setChecklist] = useState([])
  const [newItem, setNewItem] = useState('')
  const [isAddingItem, setIsAddingItem] = useState(false)

// Default luggage items - stores translation keys, not translated text
    const getDefaultItems = () => [
      // Clothing
      { id: 'clothes1', nameKey: 'luggage.items.underwear', categoryKey: 'luggage.categories.clothing',      
  checked: false },
      { id: 'clothes2', nameKey: 'luggage.items.socks', categoryKey: 'luggage.categories.clothing',
  checked: false },
      { id: 'clothes3', nameKey: 'luggage.items.tshirts', categoryKey: 'luggage.categories.clothing',        
  checked: false },
      { id: 'clothes4', nameKey: 'luggage.items.pants', categoryKey: 'luggage.categories.clothing',
  checked: false },
      { id: 'clothes5', nameKey: 'luggage.items.sweater', categoryKey: 'luggage.categories.clothing',        
  checked: false },
      { id: 'clothes6', nameKey: 'luggage.items.sleepwear', categoryKey: 'luggage.categories.clothing',      
  checked: false },
      { id: 'clothes7', nameKey: 'luggage.items.comfortableShoes', categoryKey:
  'luggage.categories.clothing', checked: false },
      { id: 'clothes8', nameKey: 'luggage.items.dressShoes', categoryKey: 'luggage.categories.clothing',     
  checked: false },
      { id: 'clothes9', nameKey: 'luggage.items.swimwear', categoryKey: 'luggage.categories.clothing',       
  checked: false },

      // Toiletries
      { id: 'toiletry1', nameKey: 'luggage.items.toothbrush', categoryKey:
  'luggage.categories.toiletries', checked: false },
      { id: 'toiletry2', nameKey: 'luggage.items.shampoo', categoryKey: 'luggage.categories.toiletries',     
  checked: false },
      { id: 'toiletry3', nameKey: 'luggage.items.bodyWash', categoryKey: 'luggage.categories.toiletries',    
   checked: false },
      { id: 'toiletry4', nameKey: 'luggage.items.deodorant', categoryKey:
  'luggage.categories.toiletries', checked: false },
      { id: 'toiletry5', nameKey: 'luggage.items.razor', categoryKey: 'luggage.categories.toiletries',       
  checked: false },
      { id: 'toiletry6', nameKey: 'luggage.items.sunscreen', categoryKey:
  'luggage.categories.toiletries', checked: false },
      { id: 'toiletry7', nameKey: 'luggage.items.moisturizer', categoryKey:
  'luggage.categories.toiletries', checked: false },
      { id: 'toiletry8', nameKey: 'luggage.items.contacts', categoryKey: 'luggage.categories.toiletries',    
   checked: false },

      // Documents
      { id: 'docs1', nameKey: 'luggage.items.passport', categoryKey: 'luggage.categories.documents',
  checked: false },
      { id: 'docs2', nameKey: 'luggage.items.tickets', categoryKey: 'luggage.categories.documents',
  checked: false },
      { id: 'docs3', nameKey: 'luggage.items.hotelReservations', categoryKey:
  'luggage.categories.documents', checked: false },
      { id: 'docs4', nameKey: 'luggage.items.insurance', categoryKey: 'luggage.categories.documents',        
  checked: false },
      { id: 'docs5', nameKey: 'luggage.items.emergencyContacts', categoryKey:
  'luggage.categories.documents', checked: false },

      // Electronics
      { id: 'electronics1', nameKey: 'luggage.items.phone', categoryKey:
  'luggage.categories.electronics', checked: false },
      { id: 'electronics2', nameKey: 'luggage.items.camera', categoryKey:
  'luggage.categories.electronics', checked: false },
      { id: 'electronics3', nameKey: 'luggage.items.powerBank', categoryKey:
  'luggage.categories.electronics', checked: false },
      { id: 'electronics4', nameKey: 'luggage.items.adapter', categoryKey:
  'luggage.categories.electronics', checked: false },
      { id: 'electronics5', nameKey: 'luggage.items.headphones', categoryKey:
  'luggage.categories.electronics', checked: false },

      // Essentials
      { id: 'essentials1', nameKey: 'luggage.items.medications', categoryKey:
  'luggage.categories.essentials', checked: false },
      { id: 'essentials2', nameKey: 'luggage.items.firstAid', categoryKey:
  'luggage.categories.essentials', checked: false },
      { id: 'essentials3', nameKey: 'luggage.items.snacks', categoryKey: 'luggage.categories.essentials',    
   checked: false },
      { id: 'essentials4', nameKey: 'luggage.items.waterBottle', categoryKey:
  'luggage.categories.essentials', checked: false },
      { id: 'essentials5', nameKey: 'luggage.items.travelPillow', categoryKey:
  'luggage.categories.essentials', checked: false }
    ]

  useEffect(() => {
    loadChecklist()
  }, [])

  const loadChecklist = () => {
    const tripData = Storage.getTripData()
    const savedLuggage = tripData.luggage || []

    if (savedLuggage.length === 0) {
      // First time - initialize with default items
      const defaultItems = getDefaultItems()
      setChecklist(defaultItems)
      saveLuggage(defaultItems)
    } else {
      setChecklist(savedLuggage)
    }
  }

  const saveLuggage = (items) => {
    const tripData = Storage.getTripData()
    tripData.luggage = items
    Storage.saveTripData(tripData)
  }

  const toggleItem = (id) => {
    const updatedChecklist = checklist.map(item =>
      item.id === id ? { ...item, checked: !item.checked } : item
    )
    setChecklist(updatedChecklist)
    saveLuggage(updatedChecklist)
  }

    const addCustomItem = () => {
      if (!newItem.trim()) return

      const customItem = {
        id: `custom_${Date.now()}`,
        name: newItem.trim(),
        categoryKey: 'luggage.customCategory',
        checked: false
      }
    const updatedChecklist = [...checklist, customItem]
    setChecklist(updatedChecklist)
    saveLuggage(updatedChecklist)
    setNewItem('')
    setIsAddingItem(false)
  }

  const removeItem = (id) => {
    const updatedChecklist = checklist.filter(item => item.id !== id)
    setChecklist(updatedChecklist)
    saveLuggage(updatedChecklist)
  }

// Group items by category, translating category keys
    const groupedItems = checklist.reduce((acc, item) => {
      const category = item.categoryKey ? t(item.categoryKey) : item.category
      if (!acc[category]) acc[category] = []
      acc[category].push(item)
      return acc
    }, {})

  const getProgress = () => {
    const total = checklist.length
    const checked = checklist.filter(item => item.checked).length
    return { checked, total, percentage: total > 0 ? Math.round((checked / total) * 100) : 0 }
  }

  const progress = getProgress()

  const content = (
    <>
      {/* Header */}
      {!embedded && <div style={{
        textAlign: 'center',
        marginBottom: '30px',
        paddingTop: '60px'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '900',
          color: '#8B7355',
          margin: '0 0 8px 0',
          letterSpacing: '2px',
          fontFamily: "'Noto Serif', serif",
          textTransform: 'uppercase'
        }}>{t('luggage.title')}</h1>
        <p style={{
          fontSize: '14px',
          color: '#8B7355',
          margin: '0 0 16px 0',
          opacity: '0.7'
        }}>{userData.destination?.toUpperCase() || t('notes.yourJourney')}</p>
        
        {/* Progress Bar */}
        <div style={{
          background: 'white',
          borderRadius: '25px',
          padding: '12px 20px',
          margin: '0 auto 16px auto',
          maxWidth: '300px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#B8A082',
            marginBottom: '8px'
          }}>
            {t('luggage.itemsPacked', { checked: progress.checked, total: progress.total, percentage: progress.percentage })}
          </div>
          <div style={{
            background: '#ede4d3',
            height: '8px',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              background: '#C4714A',
              height: '100%',
              width: `${progress.percentage}%`,
              borderRadius: '4px',
              transition: 'width 0.3s ease'
            }}></div>
          </div>
        </div>
      </div>}

      {/* Add Item Section */}
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '20px',
        margin: '0 0 20px 0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        {!isAddingItem ? (
          <button
            onClick={() => setIsAddingItem(true)}
            style={{
              background: '#C4714A',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: '25px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            {t('luggage.addCustomItem')}
          </button>
        ) : (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input
              type="text"
              value={newItem}
              onChange={(e) => setNewItem(e.target.value)}
              placeholder={t('luggage.placeholderItem')}
              style={{
                flex: '1',
                padding: '12px 16px',
                border: '2px solid #ede4d3',
                borderRadius: '25px',
                fontSize: '14px',
                outline: 'none'
              }}
              onKeyPress={(e) => e.key === 'Enter' && addCustomItem()}
              autoFocus
            />
            <button
              onClick={addCustomItem}
              style={{
                background: '#C4714A',
                color: 'white',
                border: 'none',
                padding: '12px 16px',
                borderRadius: '25px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              {t('buttons.add')}
            </button>
            <button
              onClick={() => {
                setIsAddingItem(false)
                setNewItem('')
              }}
              style={{
                background: '#ccc',
                color: 'white',
                border: 'none',
                padding: '12px 16px',
                borderRadius: '25px',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              {t('buttons.cancel')}
            </button>
          </div>
        )}
      </div>

      {/* Checklist by Category */}
      {Object.entries(groupedItems).map(([category, items]) => (
        <div key={category} style={{
          background: 'white',
          borderRadius: '16px',
          padding: '20px',
          margin: '0 0 16px 0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#B8A082',
            margin: '0 0 16px 0',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>{category}</h3>
          
          {items.map(item => (
            <div key={item.id} style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 0',
              borderBottom: '1px solid #f0f0f0'
            }}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                flex: '1',
                cursor: 'pointer',
                fontSize: '14px',
                color: item.checked ? '#999' : '#333'
              }}>
                <input
                  type="checkbox"
                  checked={item.checked}
                  onChange={() => toggleItem(item.id)}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '12px',
                    accentColor: '#C4714A'
                  }}
                />
                   <span style={{
                    textDecoration: item.checked ? 'line-through' : 'none'
                  }}>
                    {item.nameKey ? t(item.nameKey) : item.name}
                  </span>
              </label>

               {(item.categoryKey === 'luggage.customCategory' || item.category ===
  t('luggage.customCategory')) && (
                <button
                  onClick={() => removeItem(item.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#ccc',
                    fontSize: '18px',
                    cursor: 'pointer',
                    padding: '4px'
                  }}
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      ))}

      {/* Back Button */}
      {!embedded && <div style={{ textAlign: 'center', margin: '20px 0' }}>
        <button
          style={{
            background: 'transparent',
            color: '#8B7355',
            border: '2px solid #8B7355',
            padding: '12px 24px',
            borderRadius: '25px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
          onClick={() => onNavigate('home')}
        >
          {t('navigation.backToHome')}
        </button>
        </div>}
    </>
  )

  if (embedded) return content

  return (
    <PremiumGate feature="luggage_management" onNavigate={onNavigate}>
      <div className="container luggage-checklist" style={{
        background: 'linear-gradient(135deg, #f5f1eb 0%, #ede4d3 100%)',
        minHeight: '100vh',
        padding: '20px',
        position: 'relative'
      }}>
        <HomeButton onNavigate={onNavigate} />
        {content}
      </div>
    </PremiumGate>
  )
}

export default Luggage